<template>
  <v-dialog v-model="dialog" persistent max-width="290">
    <v-card>
      <v-card-title class="px-3">
        <span class="text-h6">Informe seus dados</span>
      </v-card-title>
      <v-card-text class="px-1">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container>
            <v-row>
              <v-col cols="12" class="pb-0">
                <v-label class="caption">Selecione uma opção</v-label>
                <v-radio-group v-model="isRne" row>
                  <v-radio label="RNE" :value="true"></v-radio>
                  <v-radio label="CPF" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" class="pb-0">
                <v-text-field
                    :label="isRne ? 'RNE' : 'CPF'"
                    v-model="order.document"
                    :v-mask="isRne ? '##############' : '###.###.###-##'"
                    :rules="isRne ? ruleRne : ruleDocument"
                ></v-text-field>
              </v-col>

              <v-col cols="12" class="py-0" v-if="configs.require_table_number && !hasTable">
                <v-text-field
                    label="Mesa"
                    v-model="order.table_number"
                    :rules="ruleTableNumber"
                ></v-text-field>
              </v-col>

              <v-col cols="12" class="py-0" v-if="configs.require_customer_service">
                <v-text-field
                    label="Comanda"
                    v-model="order.customer_service_code"
                    :rules="ruleCustomerService"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="darken-1" text @click="$emit('close')">
          Cancelar
        </v-btn>
        <v-btn :disabled="!valid" color="primary darken-1" text @click="validate">
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mask} from 'vue-the-mask'

export default {
  name: "DialogConfirmationRequest",
  props: ['dialog'],
  directives: {mask},
  data: (vm) => ({
    isRne: false,
    valid: true,
    order: {document: '', customer_service_code: '', table_number: '', isCpf: true},
    ruleDocument: [
      v => !!v || 'CPF é obrigatório',
      v => vm.validateDocument(v) || 'CPF inválido',
    ],
    ruleRne: [
      v => !!v || 'RNE é obrigatório',
    ],
    ruleCustomerService: [
      v => !!v || 'A comanda é obrigatória',
    ],
    ruleTableNumber: [
      v => !!v || 'A mesa é obrigatória',
    ],
  }),
  setup() {
    const configs = _config.functionalities.digitalmenu.configs
    return {configs}
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.order.isCpf = !this.isRne;
        this.$emit('confirm', this.order)
      }
    }
  },
  computed: {
    hasTable() {
      return !!new URLSearchParams(window.location.search).get('t')
    }
  }
}
</script>

<style scoped>
</style>
